import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfigModule } from 'NewAngular/config/config.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { ComparablesModalModule } from 'SecuritiesApp/ts/features/comparables-modal/comparables-modal.module';
import { HoldingsComparisonTableModule } from 'SecuritiesApp/ts/features/holdings-comparison-table/holdings-comparison-table.module';
import * as i0 from "@angular/core";
export class HoldingsComparisonModule {
}
HoldingsComparisonModule.ɵfac = function HoldingsComparisonModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsComparisonModule)(); };
HoldingsComparisonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsComparisonModule });
HoldingsComparisonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ComparablesModalModule,
        ConfigModule,
        HoldingsComparisonTableModule,
        IconModule,
        FormsModule,
        SingleSelectDropdownModule] });
